import { Box, Button, Text } from '@chakra-ui/react'
import { Icon } from 'components/atoms'
import React, { memo } from 'react'

interface NoNotificationProps {
    onRefreshPage: VoidFunction
}

const NoNotifications: React.FC<NoNotificationProps> = ({ onRefreshPage }) => {
    return (
        <Box
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            height={'400px'}
            textAlign="center"
            p={6}
            bgGradient="linear(to-b, gray.50, gray.100)"
            borderRadius="lg"
            shadow="xs"
        >
            <Icon name="bell" size={64} color="gray.400" />
            <Text fontSize="2xl" fontWeight="bold" color="gray.700" mt={4}>
                Nenhuma Notificação Encontrada
            </Text>
            <Text fontSize="md" color="gray.500" my={2} mb={8}>
                Você está atualizado! Assim que houver novas notificações, elas
                aparecerão aqui.
            </Text>

            <Button colorScheme="primary" size={'md'} onClick={onRefreshPage}>
                Atualizar página
            </Button>
        </Box>
    )
}

export default memo(NoNotifications)
